const COOKIE = 'sidebar_state'; // written by @repo/ui's SidebarProvider on toggle
const EXPANDED_MIN_WIDTH = 1024; // handoff 01-shell §4: 768–1023 = rail by default

/** Initial open state for the shell sidebar: the persisted cookie wins; with
 *  no cookie, tablets (<1024) start collapsed and desktops expanded. */
export function readSidebarDefaultOpen(opts?: { cookie?: string; width?: number }): boolean {
  const cookie = opts?.cookie ?? (typeof document !== 'undefined' ? document.cookie : '');
  const width = opts && 'width' in opts ? opts.width : typeof window !== 'undefined' ? window.innerWidth : undefined;
  const m = cookie.match(new RegExp(`(?:^|; )${COOKIE}=([^;]*)`));
  if (m) return m[1] !== 'false';
  if (width === undefined) return true;
  return width >= EXPANDED_MIN_WIDTH;
}
